import { useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Link } from "react-router-dom";
import { fetchTransactions } from "../../features/transaction/transactionSlice";
import Transaction from "./Transaction";

export default function Transactions({triggerEdit, setTriggerEdit}) {
  const dispatch = useDispatch();

  const { transactions, isLoading, isError } = useSelector(
    (state) => state.transaction
  );

  useEffect(() => {
    dispatch(fetchTransactions());
  }, [dispatch]);

  // decide what to render
  let content = null;
  let seeMore = null;
  if (isLoading) content = <p>Loading...</p>;

  if (!isLoading && isError)
    content = <p className="error">There was an error occured</p>;

  if (!isLoading && !isError && transactions?.length > 0) {
    content = transactions
      .slice(-5)
      .reverse()
      .map((transaction) => (
        <Transaction key={transaction.id} transaction={transaction} setTriggerEdit={setTriggerEdit} />
      ));
  }
  if (!isLoading && !isError && transactions?.length > 5) {
    seeMore = (
      <button className="seemore">
        <Link to="/all_transactions">See All Transaction</Link>
      </button>
    );
  }

  if (!isLoading && !isError && transactions?.length === 0) {
    content = <p>No transactions found!</p>;
  }

  return (
    <>
      <p className="second_heading">Your Transactions:</p>

      <div className="conatiner_of_list_of_transactions">
        <ul className="showtransaction">{content}</ul>
        {seeMore}
      </div>
    </>
  );
}
